import React from 'react';

export default function BigVideoWistiaSlice(props) {
    const url = props.url;
    return (
        <div className="container margin-top margin-bottom wistia-wrapper">
            <div className="wistia-player">
                <div className="wistia_responsive_padding" style={{ padding: "56.0% 0 0 0", position: "relative" }} >
                    <div className="wistia_responsive_wrapper" style={{ height: "100%", left: "0", position: "absolute", top: "0", width: "100%" }} >
                        <iframe src={url} title="Wistia video player" allowtransparency="true" frameBorder="0" scrolling="no" className="wistia_embed" name="wistia_embed" allowFullScreen autoPlay={true} width="100%" height="100%" />
                    </div>
                </div>
                <script src="https://fast.wistia.net/assets/external/E-v1.js" async />
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// src/client/components/slices/BigVideoWistiaSlice.js